export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const SOCKET_EVENTS = {
  AUTH: 'auth',
  TRADE_ACCOUNT_UPDATE: 'trade_account_update',
  CRYPTO_PAYMENT: 'crypto_payment',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  PAIR_TICK_ALL: 'pair_tick_all',
  PAIR_TICK_ALL_LEAVE: 'pair_tick_all_leave',
  ASSET_BOUGHT: 'asset_bought',
  ASSET_SOLD: 'asset_sold',
  PAIR_INVENTORY_UPDATE: 'pair_inventory_update',
  PAIR_TICK: 'pair_tick',
  PAIR_TICK_LEAVE: 'pair_tick_leave',
};
